import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';

const NovaSala = () => {
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [selectedColor, setSelectedColor] = useState('#000000');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData(event.target);
      const data = {
        name: formData.get('name'),
        color: formData.get('color')
      };

      const response = await authFetch('room', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) throw new Error('Erro ao cadastrar sala');

      showNotification('success', 'Sala cadastrada com sucesso!');
      navigate('/Salas');
    } catch (error) {
      showNotification('danger', 'Erro ao cadastrar sala');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content">
      <h3 className="font-weight-bolder mb-3">Nova Sala</h3>
      <div className="card">
        <div className="card-body p-3">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">Nome</label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="color" className="form-label">Cor</label>
              <div className="d-flex align-items-center gap-3">
                <input
                  type="color"
                  className="form-control form-control-color"
                  id="color"
                  name="color"
                  value={selectedColor}
                  onChange={(e) => setSelectedColor(e.target.value)}
                  style={{
                    width: '50px',
                    height: '50px',
                    padding: '2px'
                  }}
                  required
                />
                <div 
                  className="rounded-circle border"
                  style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: selectedColor
                  }}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end gap-2">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate('/Salas')}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NovaSala; 